/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Tag_Standar_RequiredInputs */

const es_co2_error_tag_standar_required = /** @type {(inputs: Error_Tag_Standar_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indica si quieres etiquetar a @Standar en este registro.`)
};

/**

* @param {Error_Tag_Standar_RequiredInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_tag_standar_required = /** @type {((inputs?: Error_Tag_Standar_RequiredInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Tag_Standar_RequiredInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_tag_standar_required(inputs)
});